import { isEmpty } from 'lodash';
const cssClass = 'PrivateJetTripSearch';

const selectors = {
	component: `.${cssClass}`,
	dropdown: `.${cssClass} .Dropdown-field`,
	findYourTripButton: `.${cssClass} .PrivateJetTripSearch-cta a`,
};

export default function initPrivateJetTripSearch() {
	const searchComponents = document.querySelectorAll(selectors.component);
	searchComponents.forEach(component => {
		const button = component.querySelector(selectors.findYourTripButton);
		const dropdowns = component.querySelectorAll(selectors.dropdown);
		if (button && dropdowns) {
			const initialButtonHref = button.attributes.href.value;
			dropdowns.forEach(dropdown => {
				dropdown.addEventListener('change', () => {
					let activeFilters = [];
					dropdowns.forEach(dropdown => {
						if (!isEmpty(dropdown.value)) {
							activeFilters.push(dropdown.value);
						}
					});
					button.attributes.href.value = `${initialButtonHref}?filters=${activeFilters.join(',')}`;
				});
			});
		}
	});
}
